import styled from 'styled-components';
import { ReportFormatNumber } from '../../../../func/Function';
import { useEffect, useState } from 'react';
import { uesrGradeType } from '../../../../utils/auth';
import ActionCostsLimitTable from './ActionCostsLimitTable';
interface DataProps {
  name: string;
  desc: string;
  value: string;
}

interface AcutioncostsProps {
  data: DataProps[];
  isExample?: boolean;
}

const AuctionCosts = ({ data, isExample }: AcutioncostsProps) => {
  const [userGrade, setUserGrade] = useState<string | null>(null);

  useEffect(() => {
    if (isExample) return;
    const fetchUserGrade = async () => {
      try {
        const grade = await uesrGradeType();
        setUserGrade(grade);
      } catch (error) {
        console.error('유저 등급 정보 가져오기 실패:', error);
      }
    };

    fetchUserGrade();
  }, []);
  // console.log('AuctionCosts', data);

  const noIndexItems = [
    '청구금액',
    '경매신청비용 소계',
    '예납금 소계',
    '경매집행비용 총계',
  ]; // 번호를 0으로 설정할 항목들
  let currentIndex = 1; // 기본 번호 1부터 시작

  return (
    <Container id="경매집행비용">
      <Title>경매집행비용</Title>
      {/* Todo: 지역 멤버십 연결 */}
      {/* <div style={{ marginBottom: '60px' }}>
        <ActionCostsLimitTable isRegion />
      </div> */}
      {!isExample && !userGrade ? (
        <div style={{ marginBottom: '60px' }}>
          <ActionCostsLimitTable />
        </div>
      ) : (
        <Content>
          <SingleRowTable>
            <TableRow>
              <SingleRowTableHeadCell width="100%">
                청구금액
              </SingleRowTableHeadCell>
              <SingleRowTableBodyCell width="100%">
                {ReportFormatNumber(
                  Number(data.find((item) => item.name === '청구금액')?.value),
                )}
              </SingleRowTableBodyCell>
            </TableRow>
          </SingleRowTable>
          <div
            style={{
              borderTop: '1px solid #222',
              width: '100%',
            }}
          >
            <table
              style={{
                borderCollapse: 'collapse',
                // borderTop: '1px solid #222',
                width: '100%',
              }}
            >
              <thead>
                <tr>
                  <TableHeadTh width={'17%'}>번호</TableHeadTh>
                  <TableHeadTh width={'19%'}>항목</TableHeadTh>
                  <TableHeadTh width={'32%'}>금액</TableHeadTh>
                  <TableHeadTh width={'32%'}>비고</TableHeadTh>
                </tr>
              </thead>
              <tbody>
                {data
                  .filter((item) => item.name !== '청구금액') // "청구금액" 제외
                  .map((item, index) => {
                    let displayIndex = 0; // 기본적으로 번호는 0으로 설정

                    // '청구금액'과 '경매신청비용 소계' 항목은 번호를 0으로 설정
                    if (noIndexItems.includes(item.name)) {
                      displayIndex = 0; // 번호 0으로 설정
                    } else {
                      displayIndex = currentIndex++; // 그 외 항목은 번호 증가
                    }

                    let color = item.value;
                    return (
                      <TableRowWrapper name={item.name} key={index}>
                        {/* 번호 */}
                        <TablebodyTd width={'80px'}>
                          {displayIndex !== 0 ? displayIndex : ''}
                        </TablebodyTd>
                        {/* 항목명 */}
                        <TablebodyTd width={'210px'} name={`${item.name}`}>
                          {item.name}
                        </TablebodyTd>
                        {/* 금액 */}
                        <TablebodyTd width={'289px'}>
                          {ReportFormatNumber(item.value)}
                        </TablebodyTd>
                        {/* 비고 */}
                        <TablebodyTd width={'289px'}>
                          {noIndexItems.includes(item.name)
                            ? item.desc === '' // 비고가 빈 값일 경우 '!!'로 출력
                              ? ''
                              : item.desc
                            : item.desc === ''
                              ? '-'
                              : item.desc}
                        </TablebodyTd>
                      </TableRowWrapper>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </Content>
      )}
    </Container>
  );
};

export default AuctionCosts;

interface WidthProps {
  width: string;
  name?: string;
}

interface TableRowProps {
  name: string;
}

const TableRowWrapper = styled.tr<TableRowProps>`
  border-bottom: 1px solid #e1e2e4;
  background-color: ${(props) => {
    if (props.name === '경매신청비용 소계' || props.name === '예납금 소계') {
      return '#E6F3FF'; // name이 '1'일 경우 배경색 빨간색
    } else if (props.name === '경매집행비용 총계') {
      return '#D3D3D3'; // name이 '2'일 경우 배경색 파란색
    }
    return 'none'; // 그 외의 경우 배경색 없음
  }};

  /* tr의 하위 td, th에 font-weight,color 적용 */
  td,
  th {
    color: ${(props) => {
      if (props.name === '경매신청비용 소계' || props.name === '예납금 소계') {
        return '#008AFF';
      }
      return '#171e26'; // 그 외의 경우 배경색 없음
    }};
    font-weight: ${(props) =>
      props.name === '경매집행비용 총계' ? '700' : '500'};
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #fff;
  padding: 32px 16px;
`;

const Title = styled.div`
  width: 100%;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 31.9px */
  letter-spacing: -0.44px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-end;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TableHeadTh = styled.th<WidthProps>`
  width: ${(props) => props.width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  &:last-child {
    border-right: none;
  }
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 6px 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;
  &:last-child {
    border-right: none;
  }
`;

const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #222;
`;
const SingleRowTableHeadCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-bottom: 1px solid #e8e9ea;
  padding: 6px 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #616161;
`;
